import Button from "../../components/common/button/Button";
import TitleUpdater from "../../components/common/title/TitleUpdater";
import styles from "./NotFound.module.scss";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div id={styles.not_found_page}>
      <TitleUpdater title="Page not found" />
      <div className={styles.not_found_image}>
        <div className={styles.content}>
          <h1 className={styles.err_status}>404</h1>
          <p className={styles.oops}>Oops, Page Not Found :(</p>
          <div className={styles.not_found_btn}>
            <Button onClick={() => navigate("/")}>Go To Dashboard</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
